import React from 'react';

/**
 * Reusable loading spinner component
 */
function LoadingState({ message = 'Loading...' }) {
  return (
    <div className="content-loading">
      {message}
    </div>
  );
}

export default LoadingState;
